import React, { useState, useEffect } from 'react';
import './Slideshow.css';
import imgSld1 from '../../assets/images/slideshow/1.jpg';
import imgSld2 from '../../assets/images/slideshow/2.jpg';
import imgSld3 from '../../assets/images/slideshow/3.png';
import imgSld4 from '../../assets/images/slideshow/4.png';

const Slideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "معالج الصوت Arctic - 4 نطاقات",
      subtitle: "هل أنت شغوف بمعالجة الصوت؟",
      description: "مجموعتنا المتميزة ستجعل محطتك تتميز عن المنافسة. معالج صوت FM متطور بتقنية 4 نطاقات لأفضل جودة صوت",
      image: imgSld1,
      cta: "اقرأ المزيد"
    },
    {
      id: 2,
      title: "مضخمات FM من سلسلة COBALT",
      subtitle: "مضخمات FM عالية الأداء",
      description: "تتميز مضخمات COBALT FM بنظام القيادة المزدوجة الفريد مع مدخلات طاقة منخفضة، مما يوفر لك تكرار إضافي للحماية",
      image: imgSld2,
      cta: "اقرأ المزيد"
    },
    {
      id: 3,
      title: "عرض COBALT التوضيحي المباشر",
      subtitle: "استكشف الميزات المتاحة",
      description: "اكتشف جميع الإمكانيات والميزات المتقدمة لمعدات COBALT من خلال العرض التوضيحي التفاعلي المباشر",
      image: imgSld3,
      cta: "جرب العرض التوضيحي"
    },
    {
      id: 4,
      title: "مرسلات FM من سلسلة Cobalt",
      subtitle: "من 10 واط إلى 5 كيلو واط - مرسل FM مكتمل الميزات",
      description: "جميع مرسلات COBALT تتمتع بجودة صوت فائقة ووضوح صوتي مذهل بفضل تقنية القناة الرقمية المباشرة",
      image: imgSld4,
      cta: "اقرأ المزيد"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="home" className="slideshow-container">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`slide ${index === currentSlide ? 'active' : ''}`}
          style={{ 
            backgroundImage: `linear-gradient(rgba(0, 86, 157, 0.4), rgba(0, 61, 107, 0.4)), url(${slide.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="slide-content">
              <h1>{slide.title}</h1>
              <h2 style={{ fontSize: '1.8rem', fontWeight: '400', marginBottom: '1rem', opacity: '0.9' }}>
                {slide.subtitle}
              </h2>
              <p>{slide.description}</p>
              <a href="#products" className="cta-button">
                {slide.cta}
              </a>
          </div>
        </div>
      ))}
      
      <div className="slide-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`الانتقال إلى الشريحة ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Slideshow;
